(()=>{
  const $=(selector,root=document)=>root.querySelector(selector);
  const $$=(selector,root=document)=>[...root.querySelectorAll(selector)];
  const toast=message=>{
    const element=$('#th-toast');
    if(!element)return;
    element.textContent=message;
    element.classList.add('show');
    clearTimeout(window.thToastTimer);
    window.thToastTimer=setTimeout(()=>element.classList.remove('show'),5000);
  };
  window.thToast=toast;

  const applyProductFilters=(root,filters=[])=>{
    const selected=[...new Set(filters.filter(value=>['men','women','gs','downhill','junior'].includes(value)))];
    $$('[data-filter]',root).forEach(button=>{
      const active=button.dataset.filter==='all'?selected.length===0:selected.includes(button.dataset.filter);
      button.classList.toggle('active',active);
      button.setAttribute('aria-pressed',String(active));
    });
    let visibleCount=0;
    $$('[data-category]',root).forEach(card=>{
      const categories=(card.dataset.category||'').split(/\s+/);
      const visible=selected.length===0||selected.every(value=>categories.includes(value));
      card.hidden=!visible;
      if(visible)visibleCount+=1;
    });
    const count=$('[data-product-count]',root);
    if(count)count.textContent=`${visibleCount} ${visibleCount===1?'product':'products'}`;
    const productRail=$('.th-real-products',root);
    if(productRail)productRail.scrollLeft=0;
  };

  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-search-open],[data-goggle-open],[data-size-guide-open]');
    if(trigger){
      const target=trigger.hasAttribute('data-search-open')?'#th-search':trigger.hasAttribute('data-size-guide-open')?'#th-size-guide':'#th-goggle-dialog';
      $(target)?.showModal();
    }
    const close=event.target.closest('[data-close]');
    if(close)close.closest('dialog')?.close();
    const menu=event.target.closest('[data-menu]');
    if(menu){
      const open=$('.th-header nav').classList.toggle('open');
      menu.setAttribute('aria-expanded',String(open));
    }
    const filter=event.target.closest('[data-filter]');
    if(filter){
      const root=filter.closest('section')||document;
      applyProductFilters(root,filter.dataset.filter==='all'?[]:[filter.dataset.filter]);
    }
  });

  $$('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const bounds=dialog.getBoundingClientRect();
    if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
  }));

  if(window.TH_LOCAL){
    $('#th-newsletter')?.addEventListener('submit',event=>{
      event.preventDefault();
      toast('Local preview: newsletter signup will connect to Shopify when published.');
    });
    $$('[data-local-form]').forEach(form=>form.addEventListener('submit',event=>{
      event.preventDefault();
      toast('Local preview: your message has not been sent.');
    }));
  }
  const collectionRoot=$('.th-collection-grid');
  if(collectionRoot){
    const queryFilter=new URLSearchParams(location.search).get('filter');
    let initialFilters=queryFilter?queryFilter.split(','):[];
    if(initialFilters.length===0){
      const handle=location.pathname.split('/').filter(Boolean).pop()||'';
      if(handle.startsWith('womens')||handle.startsWith('girls'))initialFilters.push('women');
      else if(handle.startsWith('mens')||handle.startsWith('boys'))initialFilters.push('men');
      if(handle.includes('downhill'))initialFilters.push('downhill');
      else if(handle.includes('junior'))initialFilters.push('junior');
      else if(handle.includes('gs'))initialFilters.push('gs');
    }
    applyProductFilters(collectionRoot,initialFilters);
  }
})();

(()=>{
  const $=(selector,root=document)=>root.querySelector(selector);
  const $$=(selector,root=document)=>[...root.querySelectorAll(selector)];
  const cartKey='tomahawk-preview-cart-client-edits';
  const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(Number(cents||0)/100);
  const readCart=()=>{try{return JSON.parse(localStorage.getItem(cartKey)||'[]')}catch{return []}};
  const saveCart=cart=>{
    localStorage.setItem(cartKey,JSON.stringify(cart));
    updateCount(cart.reduce((sum,item)=>sum+item.quantity,0));
  };
  const updateCount=count=>$$('[data-cart-count]').forEach(element=>element.textContent=count);
  const drawer=$('#th-cart-drawer');
  const overlay=$('.th-cart-overlay');
  const drawerItems=$('[data-cart-drawer-items]');
  const drawerFoot=$('[data-cart-drawer-foot]');
  let drawerOpener=null;

  if(window.TH_LOCAL)updateCount(readCart().reduce((sum,item)=>sum+item.quantity,0));

  function cartArtwork(item,image){
    const artwork=document.createElement('div');
    artwork.className='th-cart-art';
    artwork.append(image);
    if(/FIS Approved/i.test(item.product_title||item.title||'')){
      const template=$('#th-cart-fis-template');
      if(template)artwork.append(template.content.cloneNode(true));
    }
    return artwork;
  }

  function createDrawerItem(item){
    const line=document.createElement('article');
    line.className='th-cart-drawer-line';
    const image=document.createElement('img');
    image.src=item.image?.src||item.image||'';
    image.alt='';
    image.width=84;
    image.height=105;
    const details=document.createElement('div');
    details.className='th-cart-drawer-line-copy';
    const title=document.createElement('h3');
    const link=document.createElement('a');
    link.href=item.url||item.product_url||(item.handle?`/products/${item.handle}`:'/cart');
    link.textContent=item.product_title||item.title;
    title.append(link);
    const variant=document.createElement('p');
    variant.textContent=item.variant_title||item.variant||'';
    const controls=document.createElement('div');
    controls.className='th-cart-drawer-controls';
    const decrease=document.createElement('button');
    decrease.type='button';
    decrease.dataset.cartDelta='-1';
    decrease.dataset.cartLine=item.key||item.id;
    decrease.setAttribute('aria-label',`Decrease quantity for ${link.textContent}`);
    decrease.textContent='−';
    const quantity=document.createElement('span');
    quantity.textContent=item.quantity;
    quantity.setAttribute('aria-label',`Quantity ${item.quantity}`);
    const increase=document.createElement('button');
    increase.type='button';
    increase.dataset.cartDelta='1';
    increase.dataset.cartLine=item.key||item.id;
    increase.setAttribute('aria-label',`Increase quantity for ${link.textContent}`);
    increase.textContent='+';
    const remove=document.createElement('button');
    remove.type='button';
    remove.className='th-cart-drawer-remove';
    remove.dataset.cartRemoveLine=item.key||item.id;
    remove.textContent='Remove';
    controls.append(decrease,quantity,increase,remove);
    details.append(title,variant,controls);
    const price=document.createElement('strong');
    price.textContent=money(item.final_line_price??item.price*item.quantity);
    line.append(cartArtwork(item,image),details,price);
    return line;
  }

  function renderDrawer(cart){
    if(!drawerItems||!drawerFoot)return;
    const items=Array.isArray(cart)?cart:cart.items||[];
    drawerItems.replaceChildren();
    if(!items.length){
      const empty=document.createElement('div');
      empty.className='th-cart-drawer-empty';
      const heading=document.createElement('h3');
      heading.textContent='Your bag is ready for a new line.';
      const text=document.createElement('p');
      text.textContent='Choose a race suit and get ready for your next run.';
      const link=document.createElement('a');
      link.className='th-button';
      link.href='/collections/all';
      link.textContent='Explore the collection';
      empty.append(heading,text,link);
      drawerItems.append(empty);
      drawerFoot.hidden=true;
      updateCount(0);
      return;
    }
    items.forEach(item=>drawerItems.append(createDrawerItem(item)));
    const total=Array.isArray(cart)?cart.reduce((sum,item)=>sum+item.price*item.quantity,0):cart.total_price;
    $('[data-cart-drawer-total]').textContent=money(total);
    drawerFoot.hidden=false;
    updateCount(items.reduce((sum,item)=>sum+item.quantity,0));
  }

  async function refreshDrawer(){
    if(window.TH_LOCAL){renderDrawer(readCart());return}
    const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('Unable to load your bag.');
    renderDrawer(await response.json());
  }

  async function openDrawer(opener){
    if(!drawer||!overlay)return;
    drawerOpener=opener||document.activeElement;
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    overlay.setAttribute('aria-hidden','false');
    $$('[data-cart-open]').forEach(element=>element.setAttribute('aria-expanded','true'));
    document.body.classList.add('th-cart-is-open');
    try{await refreshDrawer()}catch(error){window.thToast(error.message)}
    $('[data-cart-close]',drawer)?.focus();
  }

  function closeDrawer(){
    if(!drawer||!overlay)return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    overlay.setAttribute('aria-hidden','true');
    $$('[data-cart-open]').forEach(element=>element.setAttribute('aria-expanded','false'));
    document.body.classList.remove('th-cart-is-open');
    drawerOpener?.focus?.();
  }

  async function changeDrawerLine(line,quantity){
    if(window.TH_LOCAL){
      const cart=readCart();
      const item=cart.find(entry=>String(entry.id)===String(line));
      if(item)item.quantity=quantity;
      const updated=cart.filter(entry=>entry.quantity>0);
      saveCart(updated);
      renderDrawer(updated);
      renderLocalCart();
      return;
    }
    const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:line,quantity})
    });
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||'Unable to update your bag.');
    renderDrawer(result);
  }

  document.addEventListener('click',async event=>{
    const open=event.target.closest('[data-cart-open]');
    if(open){event.preventDefault();await openDrawer(open);return}
    if(event.target.closest('[data-cart-close]')){closeDrawer();return}
    const adjustment=event.target.closest('[data-cart-delta]');
    const removal=event.target.closest('[data-cart-remove-line]');
    if(adjustment||removal){
      const control=adjustment||removal;
      const line=control.dataset.cartLine||control.dataset.cartRemoveLine;
      const current=window.TH_LOCAL
        ?readCart().find(item=>String(item.id)===String(line))?.quantity||0
        :Number(control.closest('.th-cart-drawer-line')?.querySelector('.th-cart-drawer-controls span')?.textContent||0);
      const quantity=removal?0:Math.max(0,current+Number(adjustment.dataset.cartDelta));
      control.disabled=true;
      try{await changeDrawerLine(line,quantity)}catch(error){window.thToast(error.message)}
      return;
    }
    const image=event.target.closest('[data-gallery-image]');
    if(image)selectImage(image.dataset.galleryImage);
    const qty=event.target.closest('[data-qty]');
    if(qty){
      const input=$('[name="quantity"]',qty.parentElement);
      input.value=Math.max(1,Math.min(99,Number(input.value||1)+Number(qty.dataset.qty)));
    }
    if(event.target.closest('[data-zoom]'))$('#th-zoom')?.showModal();
    const remove=event.target.closest('[data-remove]');
    if(remove){
      saveCart(readCart().filter(item=>String(item.id)!==remove.dataset.remove));
      renderLocalCart();
    }
    if(event.target.closest('[data-local-checkout]'))window.thToast('This is a local preview. Checkout is available only on the connected Shopify store.');
    if(event.target.closest('[data-sticky-submit]'))$('#th-product-form')?.requestSubmit($('#th-add-to-bag'));
  });

  document.addEventListener('keydown',event=>{
    if(!drawer?.classList.contains('open'))return;
    if(event.key==='Escape'){closeDrawer();return}
    if(event.key==='Tab'){
      const focusable=$$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled])',drawer).filter(element=>element.offsetParent!==null);
      if(!focusable.length)return;
      const first=focusable[0];
      const last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
    }
  });

  const productElement=$('#th-product-data');
  let product=null;
  if(productElement){try{product=JSON.parse(productElement.textContent)}catch{}}

  function selectImage(src){
    const image=$('#th-product-image');
    if(image)image.src=src;
    const zoomImage=$('#th-zoom .th-suit-view img');
    if(zoomImage)zoomImage.src=src;
    $$('[data-gallery-image]').forEach(button=>{
      const active=button.dataset.galleryImage===src;
      button.classList.toggle('active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  }

  if(product){
    const form=$('#th-product-form');
    const select=$('#th-variant');
    const mainButton=$('#th-add-to-bag');
    const sticky=$('[data-sticky-cart]');
    const stickyButton=$('[data-sticky-submit]');
    const first=product.variants.find(variant=>variant.available);
    if(first)select.value=first.id;

    const syncVariant=()=>{
      const option=select.selectedOptions[0];
      $('#th-product-price').textContent=option.dataset.price;
      $('[data-sticky-price]').textContent=option.dataset.price;
      $('[data-sticky-variant]').textContent=option.textContent.replace(' — Sold out','');
      const selectedVariant=product.variants.find(variant=>String(variant.id)===select.value);
      if(selectedVariant?.featured_image?.src)selectImage(selectedVariant.featured_image.src);
    };

    select.addEventListener('change',()=>{
      syncVariant();
      const url=new URL(location.href);
      url.searchParams.set('variant',select.value);
      history.replaceState(null,'',url);
    });
    const variantQuery=new URLSearchParams(location.search).get('variant');
    if(product.variants.some(variant=>String(variant.id)===variantQuery&&variant.available))select.value=variantQuery;
    syncVariant();

    form.addEventListener('submit',async event=>{
      event.preventDefault();
      const status=$('#th-product-status');
      const variant=product.variants.find(item=>String(item.id)===select.value);
      if(!variant?.available){status.textContent='This option is currently unavailable.';return}
      const quantity=Number($('[name="quantity"]',form).value);
      if(!Number.isInteger(quantity)||quantity<1||quantity>99){status.textContent='Choose a quantity between 1 and 99.';return}
      mainButton.disabled=true;
      stickyButton.disabled=true;
      try{
        if(window.TH_LOCAL){
          const cart=readCart();
          const entry=cart.find(item=>String(item.id)===String(variant.id));
          if(entry)entry.quantity+=quantity;
          else cart.push({
            id:variant.id,
            title:product.title,
            variant:variant.title,
            price:variant.price,
            quantity,
            image:variant.featured_image?.src||product.featured_image?.src||product.featured_image||product.images[0]?.src||product.images[0],
            handle:product.handle
          });
          saveCart(cart);
          status.textContent='Added to your bag.';
        }else{
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({id:variant.id,quantity})
          });
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||'Unable to add this item. Please try again.');
          status.textContent='Added to your bag.';
        }
        await openDrawer(event.submitter||mainButton);
      }catch(error){status.textContent=error.message}
      finally{mainButton.disabled=false;stickyButton.disabled=false}
    });

    if(sticky&&mainButton&&'IntersectionObserver' in window){
      new IntersectionObserver(entries=>{
        const show=!entries[0].isIntersecting;
        sticky.classList.toggle('visible',show);
        sticky.setAttribute('aria-hidden',String(!show));
      },{threshold:.15}).observe(mainButton);
    }
  }

  function renderLocalCart(){
    const target=$('#th-local-cart-items');
    if(!target)return;
    const cart=readCart();
    target.replaceChildren();
    if(!cart.length)target.innerHTML='<div class="th-empty"><h2>Your next run is waiting.</h2><p>Your bag is empty.</p><a class="th-button" href="/collections/all">Explore the collection</a></div>';
    cart.forEach(item=>{
      const row=document.createElement('article');
      row.className='th-cart-line';
      const image=document.createElement('img');
      image.src=item.image;
      image.alt=item.title;
      const body=document.createElement('div');
      const heading=document.createElement('h3');
      const link=document.createElement('a');
      link.href='/products/'+item.handle;
      link.textContent=item.title;
      heading.append(link);
      const details=document.createElement('p');
      details.textContent=item.variant+' · Qty '+item.quantity;
      const remove=document.createElement('button');
      remove.className='th-cart-remove';
      remove.dataset.remove=item.id;
      remove.textContent='Remove';
      body.append(heading,details,remove);
      const price=document.createElement('span');
      price.textContent=money(item.price*item.quantity);
      row.append(cartArtwork(item,image),body,price);
      target.append(row);
    });
    $('#th-cart-total').textContent=money(cart.reduce((sum,item)=>sum+item.price*item.quantity,0));
    $('[data-local-checkout]').disabled=!cart.length;
  }

  if(window.TH_LOCAL){renderLocalCart();renderDrawer(readCart())}
})();
